export function parsePhone(phone: string) {
    return phone.replace(/\D/g, '').match(/.{1,2}/g)?.join(' ') ?? ''
}

export function parseWysiwyg(text: string) {
    text = text.replaceAll('<table>', '<div class="table-responsive"><table class="table-4 w-100 mt-20>"')
    text = text.replaceAll('</table>', '</table></div>')
    return text
}